import React from 'react';
import { FaBrain, FaServer, FaCode, FaCheckCircle } from 'react-icons/fa';
import './IntegrationReport.css';

const IntegrationReport = () => {
  const metrics = [
    { label: "AI Latency", value: "42ms", color: "#00ffc3" },
    { label: "Neural Accuracy", value: "99.8%", color: "#ffcc00" },
    { label: "Verify Success", value: "100%", color: "#00ccff" },
    { label: "Uptime", value: "99.9x", color: "#ff44dd" }
  ];

  return (
    <section className="integration-report-comp" id="integration-report">
      <div className="section-tag" data-aos="fade-up">🇮🇳 Bharat Connect x Sampark AI x Bharat Verify</div>
      <h2 data-aos="fade-up">Integration Mastery</h2>
      <p className="section-subtitle" data-aos="fade-up">A visual breakdown of the high-fidelity synergy between Platform, Intelligence, and Verification.</p>

      <div className="report-container glass-section" data-aos="fade-up">
        <div className="metrics-summary">
          {metrics.map((m, i) => (
            <div key={i} className="metric-box">
              <span className="metric-label">{m.label}</span>
              <span className="metric-value" style={{color: m.color}}>{m.value}</span>
            </div>
          ))}
        </div>

        <div className="report-grid">
          <div className="report-card">
            <div className="report-icon"><FaBrain style={{color: '#00ffc3'}} /></div>
            <h4>Neural Genesis</h4>
            <p>Immersive moving radial mesh with liquid glass message aesthetics for a world-class portal experience.</p>
            <div className="card-progress"><div className="progress-fill" style={{width: '100%', background: '#00ffc3'}}></div></div>
          </div>
          <div className="report-card">
            <div className="report-icon"><FaServer style={{color: '#00ccff'}} /></div>
            <h4>Deep Context</h4>
            <p>Full thread history availability. Sampark AI now understands deep thread context for smarter responses.</p>
            <div className="card-progress"><div className="progress-fill" style={{width: '95%', background: '#00ccff'}}></div></div>
          </div>
          <div className="report-card">
            <div className="report-icon"><FaCode style={{color: '#ffcc00'}} /></div>
            <h4>Syntax Engine</h4>
            <p>Deployed high-fidelity ReactMarkdown with Prism Syntax Highlighting for professional code rendering.</p>
            <div className="card-progress"><div className="progress-fill" style={{width: '100%', background: '#ffcc00'}}></div></div>
          </div>
          <div className="report-card">
            <div className="report-icon"><FaCheckCircle style={{color: '#00ccff'}} /></div>
            <h4>Identity Assurance</h4>
            <p>Real-time biometric and document-based verification system integrated for 100% platform trust.</p>
            <div className="card-progress"><div className="progress-fill" style={{width: '100%', background: '#00ccff'}}></div></div>
          </div>
        </div>

        <div className="report-status-table-wrap">
          <div className="report-status-table">
            <div className="status-header">
              <span>Component</span>
              <span>Identity</span>
              <span>Status</span>
            </div>
            {[
              { name: "Bharat Connect", identity: "Platform", status: "Operational", color: "online" },
              { name: "Sampark AI", identity: "Intelligence", status: "Active", color: "online" },
              { name: "Bharat Verify", identity: "Identity", status: "Verified", color: "online" },
              { name: "Security Suite", identity: "Security", status: "Active & Calibrated", color: "online" }
            ].map((item, idx) => (
              <div key={idx} className="status-row">
                <span className="comp-name">{item.name}</span>
                <span className="badge-identity">{item.identity}</span>
                <span className={`badge-status ${item.color}`}>
                  <span className="status-dot aiPulse"></span>
                  {item.status}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntegrationReport;
